import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { apiClient } from '~admin/client';
import { logoutTaskFactory } from '~admin/interactor/login/perform-logout';
import { Paths } from '~admin/route';
import { useAdminAuthStore } from '~admin/store/admin-auth-store-provider';
import { useSuccessReaction } from '~common/hook/use-reaction';
import { useTask } from '~common/hook/use-task';
import { DataLoading } from '~web/view/components/core/data-loading.component';

export const LogoutPage: React.FunctionComponent = observer(() => {
  const adminAuthStore = useAdminAuthStore();
  const authenticated = { adminAuthStore };
  const history = useHistory();
  const logout = useTask(logoutTaskFactory);

  useEffect(() => {
    logout();
  }, []);

  useSuccessReaction(logout, () => {
    adminAuthStore.clear();
    apiClient.removeAuthorization();
    history.replace(Paths.login);
  });

  if (authenticated) {
    return <DataLoading />;
  }

  return null;
});



// WEBPACK FOOTER //
// ./view/pages/auth/logout.page.tsx